import React from 'react';
import gpt3Logo from '../../assets/logo.svg';
import './footer.css';

const Footer = () => {
  return (
    <div className="gpt3__footer section__padding">
      <div className="gpt3__footer-heading">
        <h1 className="gradient__text">Creating Stronger People Through Personal Fitness</h1>
      </div>

      <div className="gpt3__footer-btn">
        <p>Become a Member</p>
      </div>

      <div className="gpt3__footer-links">
        <div className="gpt3__footer-links_logo">
          <img src={gpt3Logo} alt="logo" />
          <p>Lorem ipsum dolor sit amet</p>
        </div>
        <div className="gpt3__footer-links_div">
          <h4>Links</h4>
          <p>Homes</p>
          <p>About Us</p>
          <p>Possibilities</p>
          <p>Our Plans</p>
          <p>Our Classes</p>
        </div>
        <div className="gpt3__footer-links_div">
          <h4>Company</h4>
          <p>Terms & Conditions</p>
          <p>Privacy Policy</p>
          <p>Contact</p>
        </div>
        <div className="gpt3__footer-links_div">
          <h4>Get in touch</h4>
          <p>182 Adelaide St E.,</p>
          <p>Toronto, ON</p>
          <p>(000) 000-0000</p>
          <p>info@thegym.com</p>
        </div>
      </div>

      <div className="gpt3__footer-copyright">
        <p>© 2024 THE GYM. All rights reserved.</p>
      </div>
    </div>
  )
}

export default Footer;